import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.store'
import $const from '@/utils/const'
import dashboard from './modules/dashboard.store'
import { actionTypes } from './actionTypes'
import _ from 'lodash'

let types = actionTypes

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isShowLoading: false,
        navigation: window.innerWidth > 1264,
        tourConsole: true,
        version: '1.1.0',
        buildVersion: process.env.VUE_APP_BUILD_VERSION
    },
    mutations: {
        [types.LOADING]: (state, payload) => {
            state.isShowLoading = payload
        },
        [types.TOGGLE_NAVIGATION]: (state) => {
            state.navigation = !state.navigation
        },
        [types.NAVIGATION] (state, val) {
            state.navigation = val
        },
        [types.TOUR_CONSOLE] (state, val) {
            state.tourConsole = val
        }
    },
    actions: {
        [types.LOADING]: (context, payload) => {
            context.commit(types.LOADING, payload)
        },
        [types.TOGGLE_NAVIGATION]: (context) => {
            context.commit(types.TOGGLE_NAVIGATION)
        },
        [types.NAVIGATION] (context, payload) {
            context.commit(types.NAVIGATION, payload)
        },
        [types.TOUR_CONSOLE]: (context, payload) => {
            context.commit(types.TOUR_CONSOLE, payload)
        }
    },
    modules: {
        user, dashboard
    },
    getters: {
        loading: state => state.isShowLoading,
        profile: state => state.user.profile,
        token: state => state.user.token,
        projects: state => state.user.projects,
        currentProjectId: state => state.user.currentProjectId,
        currentProjectType: state => {
            let projectId = state.user.currentProjectId
            let project = _.find(state.user.projects, item => item.id === projectId)
            return project ? project.project_type : ''
        },
        version: state => state.version,
        prepaidProjectCount: state => {
            let prePaidProjectList = _.filter(
                state.user.projects,
                item => item.project_type === $const.projectType.PREPAID
            )
            return prePaidProjectList.length
        }
    }
})

export default store
